import { TriangleAlert } from 'lucide-react'

/**
 * Non-production environment label (2026-10-08, Chris: "a big banner across
 * the top of all pages so people know this is not production").
 *
 * Driven by the hostname so a production build can never show it by
 * accident: any host starting with `staging` (staging-ops.siliconesplus.com)
 * is staging. `VITE_ENV_LABEL` can force a label for other environments.
 */
// eslint-disable-next-line react-refresh/only-export-components
export function environmentLabel(hostname: string = window.location.hostname): string | null {
  const forced = import.meta.env.VITE_ENV_LABEL as string | undefined
  if (forced) return forced
  return /^staging[-.]/i.test(hostname) ? 'STAGING ENVIRONMENT' : null
}

export function EnvironmentBanner() {
  const label = environmentLabel()
  if (!label) return null
  return (
    <div
      role="status"
      aria-label={label}
      className="flex shrink-0 items-center justify-center gap-3 bg-danger px-4 py-2 text-center text-lg font-bold uppercase tracking-widest text-text-inverse"
    >
      <TriangleAlert size={20} aria-hidden="true" />
      <span>{label}: not production. Test data only, changes here don't affect the live system.</span>
      <TriangleAlert size={20} aria-hidden="true" />
    </div>
  )
}

/** Banner above the page; the page keeps the rest of the viewport. */
export function WithEnvironmentBanner({ children }: { children: React.ReactNode }) {
  if (!environmentLabel()) return <>{children}</>
  return (
    <div className="flex h-full flex-col">
      <EnvironmentBanner />
      <div className="relative min-h-0 flex-1 overflow-auto">{children}</div>
    </div>
  )
}
